import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["card tw-rounded-md tw-bg-white tw-p-6 tw-text-secondary", { 'tw-shadow-sm': _ctx.emphasis }])
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2));
}
